import { Routes } from '@angular/router';
import { PartnerPortalLayoutComponent } from '../partner-portal/partner-portal-layout/partner-portal-layout.component';
import { StudentListComponent } from '../super-admin/student-list/student-list.component';
import { ViewProfileComponent } from '../student-portal/view-profile/view-profile.component';
import { ReportingComponent } from '../super-admin/reporting/reporting.component';
import { PermissionGuard } from '../guards/permission.guard';
import { UserRole } from '../models/enums/UserRole';

export const schoolAdminRoutes: Routes = [
  {
    path: 'school-portal', component: PartnerPortalLayoutComponent,
    data: { portal: 'partner' },
    children: [
      {
        path: '', redirectTo: 'students', pathMatch: 'full'
      },
      {
        path: 'students', component: StudentListComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.SchoolAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'view-profile/:id',
        component: ViewProfileComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.SchoolAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'reporting', component: ReportingComponent,
        data: {
          expectedRoles: [UserRole.SchoolAdmin],
        },
        canActivate: [PermissionGuard]
      }
    ]
  }
];

